import { get } from 'lodash';
import { convertHexToRGB } from '../../../../utils';

const styles = ({ color, fontSize }) => ({
  topPanelContainer: {
    backgroundColor: `${convertHexToRGB(get(color, 'borderColor'), 0.1)}`,
    minHeight: '120px',
    padding: '0 36px',
  },
  marginPanelContainer: {
    minHeight: '350px',
  },
  detailsContainer: {
    padding: '20px 36px',
  },
  checkCompliance: {
    color: get(color, 'success'),
    marginLeft: 18,
  },
  cancelIconForCompliance: {
    color: get(color, 'error'),
    marginLeft: 18,
  },
  greyIconForCompliance: {
    fill: get(color, 'gray'),
    marginLeft: 18,
  },
  editTagsLink: {
    float: 'left',
    padding: 4,
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
    textDecoration: 'none',
    '& ~ span': {
      borderRadius: '10px',
      color: `${get(color,'bodyText')} !important`,
    },
  },
  editPolicyTemplatesLink: {
    padding: 4,
    cursor: 'pointer',
    color: `${get(color, 'link')} !important`,
    display: 'block',
    textDecoration: 'none',
    '& ~ span': {
      borderRadius: '10px',
      color: `${get(color,'bodyText')} !important`,
    },
  },
  policyComplianceLabel: {
    fontSize: get(fontSize, 'bodyText'),
  },
  complianceStatus: {
    alignItems: 'center',
    display: 'flex',
  },
});

export default styles;
